import { LucideLoader2 } from "lucide-react";
import React from "react";

const Loader = ({
  loadingText = "Loading...",
  className = "",
  bgColor = "transparent",
  containerClassName = "",
}) => {
  const isTailwindBg =
    typeof bgColor === "string" && bgColor.startsWith("bg-");
  const isHardcodedWhite =
    typeof bgColor === "string" &&
    ["white", "#fff", "#ffffff"].includes(bgColor.toLowerCase());
  const isTransparent =
    !bgColor ||
    bgColor === "transparent" ||
    bgColor === "bg-transparent" ||
    isHardcodedWhite;
  const bgColorClass = isTransparent
    ? "bg-transparent"
    : isTailwindBg
      ? bgColor
      : "";
  const bgStyle =
    !isTransparent && !isTailwindBg
      ? { backgroundColor: bgColor }
      : undefined;
  // if text color is provided in the container className, use it, apply all text props to the text
  const textProps = containerClassName.includes("text-")
    ? containerClassName
        .split(" ")
        .filter((item) => item.includes("text-"))
        .join(" ")
    : "text-muted-foreground";
  return (
    <div
      className={`flex items-center justify-center ${bgColorClass} p-4 ${containerClassName}`}
      style={bgStyle}
    >
      {/* <div className={`loader border-t-4 border-[#6ab89a] rounded-full w-16 h-16 animate-spin ${className}`}></div> */}

      <LucideLoader2
        className={`w-16 h-16 animate-spin text-black ${className}`}
      />
      {loadingText && (
        <div className={`ml-4 text-sm ${textProps}`}>{loadingText}</div>
      )}
    </div>
  );
};

export default Loader;
